<script setup lang="ts">
import { AppMarkdownWrapper } from '@libs/ui';

import HotelDescriptionMarkdownStyles from './HotelDescriptionMarkdownStyles.vue';

interface HotelMainDescriptionProps {
  description: string;
}

const props = defineProps<HotelMainDescriptionProps>();
</script>

<template>
  <HotelDescriptionMarkdownStyles :opening-paragraph="false">
    <AppMarkdownWrapper :source="props.description" />
  </HotelDescriptionMarkdownStyles>
</template>
